import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoacabservice() {



const cardData = {
  keyword: "Mumbai to Goa Cab Service",
  heading: "Lotus Cab: Mumbai to Goa Cab Service",

headingDescription:
    "Lotus Cabs offers reliable and affordable Mumbai to Goa Cab services for family vacations, beach holidays, honeymoon trips, corporate travel, group tours, sightseeing, airport transfers, and one-way or round-trip journeys. We provide a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Mumbai, well-maintained vehicles, and safe long-distance highway travel, Lotus Cabs ensures a comfortable, convenient, and hassle-free journey from Mumbai to Goa. Whether you are traveling to North Goa or South Goa, our professional drivers and clean vehicles guarantee a relaxing road trip with memorable travel experiences.",

  top: "Top Places to Visit in Goa with Lotus Cab",

 topPlaces: [
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach, popularly known as the 'Queen of Beaches,' is Goa's most famous tourist destination and attracts visitors from across the world. The beach is renowned for its golden shoreline, exciting water sports, lively beach shacks, seafood restaurants, shopping stalls, and vibrant atmosphere. Travelers booking a Mumbai to Goa Cab with Lotus Cabs often make Calangute their first stop to experience Goa's lively beach culture and breathtaking coastal scenery."
    },
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of North Goa's most popular attractions, offering a perfect blend of adventure, relaxation, and entertainment. Visitors can enjoy parasailing, jet skiing, banana boat rides, dolphin cruises, beach cafés, seafood restaurants, and Goa's famous nightlife. It remains a favorite destination for families, couples, and groups looking for an unforgettable beach holiday."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is well known for its peaceful environment, clean shoreline, luxury resorts, beachside cafés, and exciting water sports. Unlike the busier beaches, Candolim offers a more relaxed atmosphere where visitors can unwind, enjoy spectacular sunsets, and experience the natural beauty of Goa's coastline."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a magnificent 17th-century Portuguese fort overlooking the Arabian Sea and one of Goa's most iconic heritage attractions. The historic lighthouse, massive fort walls, breathtaking sea views, and colonial architecture make it an essential destination for history enthusiasts, photographers, and sightseeing travelers."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of the most important churches in India. Famous for its remarkable Baroque architecture and the sacred relics of St. Francis Xavier, the basilica attracts pilgrims, history lovers, and international tourists throughout the year."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is among India's tallest and most spectacular waterfalls, cascading through the lush forests of the Western Ghats. Visitors can enjoy jeep safaris, trekking adventures, scenic viewpoints, and breathtaking natural beauty, making it one of the most unforgettable attractions during a Goa vacation."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach is one of South Goa's most picturesque beaches, famous for its crescent-shaped shoreline, calm waters, swaying palm trees, beach cottages, and peaceful atmosphere. It is an ideal destination for swimming, kayaking, yoga retreats, family vacations, and romantic getaways away from crowded tourist spots."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort stands atop a hill overlooking Vagator Beach and offers panoramic views of the Arabian Sea and Goa's scenic coastline. Made famous by Bollywood films, the fort is a popular destination for photography, sunset viewing, historical exploration, and enjoying the spectacular landscapes of North Goa."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is celebrated for its unique rocky shoreline, vibrant flea market, beach cafés, live music, nightlife, and stunning sunsets. It perfectly captures Goa's bohemian lifestyle and attracts travelers seeking adventure, shopping, delicious cuisine, and memorable beach experiences."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's longest and most beautiful beaches, known for its white sandy shoreline, coconut groves, water sports, seafood restaurants, and peaceful ambiance. Families, couples, and leisure travelers frequently visit Colva to relax by the sea, enjoy local Goan cuisine, and experience the tranquil charm of South Goa."
    }
],

  services: [
    {
      name: "Mumbai to Goa Cab",
      description:
        "Lotus Cab offers reliable Mumbai to Goa cab services with experienced long-distance drivers. Clean AC sedans and SUVs ensure maximum comfort during the 10–12 hour journey. Transparent per-kilometer pricing is shared before booking confirmation. Ideal for families, couples, and corporate travel. Flexible one-way and round-trip packages available. 24/7 booking assistance provided."
    },
    {
      name: "AC Cab Mumbai to Goa",
      description:
        "Fully air-conditioned vehicles available for comfortable coastal highway travel. Clean interiors maintained for hygiene and comfort. Suitable for summer road trips. Smooth and stable driving ensured. Budget-friendly pricing available. Professional chauffeurs included."
    },
    {
      name: "SUV Cab Mumbai to Goa",
      description:
        "Spacious SUV taxis perfect for group and family travel. Extra luggage capacity available for beach vacations. Strong highway performance ensures safe travel. Ideal for multi-day trips. Comfortable seating for long-distance journey. Flexible travel packages provided."
    },
    {
      name: "Luxury Cab Mumbai to Goa",
      description:
        "Premium luxury vehicles available for stylish and comfortable travel. Ideal for honeymoon couples and executive guests. Professional chauffeur-driven service included. Superior interior comfort maintained. Customized trip planning available."
    },
    {
      name: "One Way Cab Mumbai to Goa",
      description:
        "Affordable one-way drop service for Goa destinations. Pay only for single-side travel distance. Ideal for relocation or return via flight/train. Transparent billing maintained. Safe and reliable travel guaranteed."
    },
    {
      name: "Round Trip Cab Mumbai to Goa",
      description:
        "Round-trip taxi packages with flexible return scheduling. Perfect for weekend and holiday trips. Comfortable AC vehicles provided. Transparent fare breakdown shared before booking. Smooth and stress-free travel ensured."
    }
  ],

  tableData: [
    ["Mumbai to Goa Cab", "AC Cab Mumbai to Goa"],
    ["Sedan Cab Mumbai to Goa", "SUV Cab Mumbai to Goa"],
    ["Luxury Cab Mumbai to Goa", "One Way Cab Mumbai to Goa"],
    ["Round Trip Cab Mumbai to Goa", "Family Trip Cab Mumbai to Goa"],
    ["Corporate Cab Mumbai to Goa", "Weekend Trip Cab Mumbai to Goa"],
    ["Online Cab Booking Mumbai to Goa", "Budget Cab Mumbai to Goa"],
    ["Mini Bus Mumbai to Goa", "Chauffeur Driven Cab Mumbai to Goa"],
    ["Picnic Trip Cab Mumbai to Goa", "Same Day Return Cab Mumbai to Goa"],
    ["Outstation Taxi Service Mumbai to Goa", "Per Km Rate Cab Mumbai to Goa"],
    ["Best Cab Service Mumbai to Goa", "Group Tour Cab Mumbai to Goa"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Long-Distance Drivers",
      WhyChoosedescription:
        "Drivers trained for Konkan highway and ghat roads. Safe and smooth driving ensured. Professional long-distance experience provided."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Upfront pricing with no hidden charges. Complete fare breakdown shared before booking confirmation."
    },
    {
      WhyChooseheading: "Wide Fleet Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury cars, and mini buses available for all travel needs."
    },
    {
      WhyChooseheading: "24/7 Booking Availability",
      WhyChoosedescription:
        "Round-the-clock support and flexible pickup timing across Mumbai."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly",
      WhyChoosedescription:
        "Packages suitable for vacations, corporate travel, and group tours."
    },
    {
      WhyChooseheading: "Clean & Sanitized Vehicles",
      WhyChoosedescription:
        "Vehicles regularly serviced and sanitized for hygiene."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription:
        "One-way, round-trip, and multi-day packages available."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription:
        "Dedicated support team available throughout your journey."
    }
  ]
};

const faqData = [
  {
    question: "How long does Mumbai to Goa road travel take?",
    answer:
      "The journey usually takes 10 to 12 hours depending on traffic and weather conditions. Our drivers plan routes carefully for safe travel."
  },
  {
    question: "Is one-way drop service available?",
    answer:
      "Yes, affordable one-way cab service is available where you pay only for single-side distance."
  },
  {
    question: "Are SUVs recommended for Goa trip?",
    answer:
      "SUVs are ideal for family and group travel as they offer extra comfort and luggage space."
  },
  {
    question: "Do you provide luxury vehicles?",
    answer:
      "Yes, premium luxury vehicles are available for executive and honeymoon travel."
  },
  {
    question: "Is AC included in all vehicles?",
    answer:
      "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel."
  },
  {
    question: "Is corporate booking available?",
    answer:
      "Yes, corporate packages and invoice billing support are available."
  },
  {
    question: "Is online booking available?",
    answer:
      "Yes, instant booking confirmation provided online with customer support."
  },
  {
    question: "Is pricing per km transparent?",
    answer:
      "Yes, complete fare breakdown is shared before booking confirmation."
  },
  {
    question: "Is group travel available?",
    answer:
      "Yes, mini bus and SUV options are available for group tours."
  },
  {
    question: "Is same-day return possible?",
    answer:
      "Same-day return is possible depending on travel schedule and package selection."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback:
      "Booked Mumbai to Goa cab for family vacation. Very smooth journey and professional driver. Comfortable SUV and transparent pricing.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Luxury cab option was perfect for our honeymoon trip. Clean vehicle and safe driving experience.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Used service for business group travel. Mini bus was spacious and comfortable. Excellent coordination.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Rahul Joshi",
    feedback:
      "Affordable and reliable cab service. No hidden charges and smooth highway drive.",
    rating: 5
  }
];































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Goa Cab",
"image": "https://lotuscab.com/assets/images/mumbai-to-goa-cab.jpg",
"description": "Book Mumbai to Goa Cab with Lotus Cab for safe, comfortable, and affordable long-distance travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "9650"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-to-goa-cab"
}
};









  return (
    <div>
      

<Helmet>
  <title>Mumbai to Goa Cab | One Way & Round Trip Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai to Goa Cab with Lotus Cab for comfortable long-distance travel. One way and round trip taxi service with Sedan, SUV, and AC cabs, professional drivers, 24x7 support, and instant booking confirmation."
/>

<meta
 name="keywords"
 content="Mumbai to Goa Cab, Mumbai Goa Taxi, Goa Cab from Mumbai, Mumbai to Goa Taxi Service, One Way Cab Mumbai to Goa, Round Trip Cab Mumbai to Goa, Outstation Cab Mumbai to Goa, Mumbai Goa Road Trip Cab, Affordable Mumbai to Goa Cab, Cheap Mumbai to Goa Taxi, Online Mumbai Cab Booking, Sedan Cab Mumbai to Goa, SUV Cab Mumbai to Goa, Best Mumbai to Goa Cab, Lotus Cab Mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogoacabservice;